<template>
  <div class="wisdom">
    <div class="banner-wrapper">
      <img src="../assets/service/banner4.png" alt="" class="banner">
    </div>
    <div class="container-wrapper">
      <div class="top-container">
        <h3 class="top-title">
          教师智研
          <p>教师改变，课堂就会改变</p>
        </h3>
        <p class="top-describe">
          信息化互联网时代的到来，可以打破传统教师研训时间和空间的限制，借助多媒体信息化技术智慧地为教师研训提供支持，兼顾满足教师个性化的成长需求，建设一套面向教师的涵盖设计面向核心素养的学习体验、构建以学习为中心的课堂、使用评价促进学与教的教师能力标准。基于数据与教师行为表现，引导一线教师按需学习、有效学习，逐渐建立信息化背景下的教师专业发展机制，实现“五维一体”学习共同体。
        </p>
        <ul class="top-ul flex-between">
          <li v-for="item in topList" :key="item.id" class="top-li">
            <img :src="item.icon" alt="">
            <p class="top-li-title">{{item.title}}</p>
            <p class="top-li-discribe">{{item.discribe}}</p>
          </li>
        </ul>
      </div>
      <div class="bottom-container">
        <h3 class="bottom-title">
          服务内容
        </h3>
        <div class="sort">
          <ul class="sort-ul flex-align-between">
            <li class="sort-li csp" :class="{'active':selectedId == item.code}" v-for="item in sortList" :key="item.id"
              @click="changeList(item)">{{item.name}}
            </li>
          </ul>
          <button class="more csp">更多<i class="el-icon-arrow-right" style="font-size:12px"></i></button>
        </div>
        <ul class="bottom-ul">
          <li class="bottom-li csp" v-for="item in serveList" :key="item.id" @click="openUrl(item)">
            <img :src="item.cover" alt="" class="bottom-li-cover">
            <p class="bottom-li-name-big">{{item.name}}</p>
            <p class="bottom-li-name wes">{{item.name}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        topList: [{
            id: 1,
            title: '专家',
            discribe: '主题任务的确定以及活动安排的总体统筹与关键指导。',
            icon: require("../assets/service/wisdom1.png")
          },
          {
            id: 2,
            title: '管理者',
            discribe: '全程参与，组织校内各学科参训教师研讨共享，落实多学科及跨学科的融合发展。',
            icon: require("../assets/service/wisdom2.png")
          }, {
            id: 3,
            title: '教研员/骨干教师',
            discribe: '辅助专家组织教学活动，关注学员变化，保证任务落实与成果产出质量。',
            icon: require("../assets/service/wisdom3.png")
          }, {
            id: 4,
            title: '参训教师',
            discribe: '交流互动展示、在岗实践应用、深度合作研磨。',
            icon: require("../assets/service/wisdom4.png")
          }, {
            id: 5,
            title: '数据观察员',
            discribe: '学习过程监控与培训成果收集，运用平台全过程分析功能，为专家指导提供依据。',
            icon: require("../assets/service/wisdom5.png")
          }
        ],
        selectedId: 1,
        sortList: [{
            id: 1,
            name: '分层'
          },
          {
            id: 2,
            name: '分类'
          },
          {
            id: 3,
            name: '分岗'
          }
        ],
        serveList: [
          // {
          //   id: 1,
          //   cover: require("../assets/service/serve1.png"),
          //   name: '小学各学科骨干教师研修服务项目'
          // },
          // {
          //   id: 2,
          //   cover: require("../assets/service/serve2.png"),
          //   name: '小学各学科骨干教师研修服务项目'
          // },
          // {
          //   id: 3,
          //   cover: require("../assets/service/serve3.png"),
          //   name: '小学各学科骨干教师研修服务项目'
          // },
          // {
          //   id: 4,
          //   cover: require("../assets/service/serve4.png"),
          //   name: '小学各学科骨干教师研修服务项目'
          // },
          // {
          //   id: 5,
          //   cover: require("../assets/service/serve5.png"),
          //   name: '小学各学科骨干教师研修服务项目'
          // },
          // {
          //   id: 6,
          //   cover: require("../assets/service/serve6.png"),
          //   name: '小学各学科骨干教师研修服务项目'
          // },
          // {
          //   id: 7,
          //   cover: require("../assets/service/serve7.png"),
          //   name: '小学各学科骨干教师研修服务项目'
          // },
          // {
          //   id: 8,
          //   cover: require("../assets/service/serve8.png"),
          //   name: '小学各学科骨干教师研修服务项目'
          // },
        ]
      }
    },
    methods: {
      async queryKeyList() {
        let params = {
          code: 'FWXMNR'
        }
        let resData = await Api.NewHome.queryKeyList(params)
        // console.log(resData);
        if (JSON.stringify(resData.data) == '[]') return;
        this.sortList = resData.data;
        this.selectedId = resData.data[0].code;
        this.queryListByKey();
      },
      changeList(item) {
        this.selectedId = item.code;
        this.queryListByKey();
      },
      async queryListByKey() {
        this.serveList = [];
        let params = {
          commonCode: this.selectedId
        }
        let resData = await Api.NewHome.queryListByKey(params)
        // console.log(resData);
        if (JSON.stringify(resData.rows) == '[]') return;
        this.serveList = resData.rows;
      },
      openUrl(item) {
        // console.log(item);
        window.open('https://yun.cnuen.net/');
      }
    },
    mounted() {
      this.queryKeyList();
    },
  }
</script>

<style lang="less" scoped>
  .wisdom {
    .banner {
      width: 100%;
      display: block;
    }

    .container-wrapper {
      width: 1200px;
      margin: 44px auto 100px;
    }

    .top-title,
    .bottom-title {
      text-align: center;
      margin-bottom: 36px;
      font-size: 32px;
      position: relative;
      padding: 50px 0 64px;
      z-index: 2;

      &>p {
        font-size: 19px;
        color: #9B9BA3;
        margin-top: 17px;
      }
    }

    .bottom-title {
      padding: 79px 0 70px;
    }

    .top-container {
      margin-bottom: 60px;


      .top-describe {
        text-indent: 2em;
        line-height: 37px;
        color: #383838;
        font-size: 16px;
        margin-bottom: 50px;
      }

      .top-li {
        margin-right: 24px;
        border-radius: 10px;
        box-shadow: 0px 0px 13px 0px rgba(127, 127, 127, 0.14);
        padding: 42px 20px 29px 20px;
        width: calc((100% / 5));
        text-align: center;

        &:nth-child(5) {
          margin-right: 0;
        }
      }

      .top-li-title {
        margin: 30px 0 28px;
        font-weight: bold;
        font-size: 21px;
        color: #383838;
      }

      .top-li-discribe {
        text-align: left;
        line-height: 24px;
        font-size: 16px;
        color: #383838;
      }
    }

    .bottom-container {
      .sort {
        text-align: right;
      }

      .sort-ul {
        padding: 0 290px;
        margin-bottom: 23px;
      }

      .sort-li {
        margin-right: 10px;
        border: 1px solid #e6e6e6;
        width: calc(100% / 3);
        line-height: 41px;
        font-size: 16px;
        background-color: #F8F8F8;
        text-align: center;

        &:last-child {
          margin-right: 0;
        }

        &.active,
        &:hover {
          background: #5386FF;
          color: #fff;
        }
      }

      .more {
        color: #999999;
      }

      .bottom-ul {
        margin-top: 18px;
        min-height: 230px;

        .bottom-li {
          display: inline-block;
          width: calc((100% / 4) - 18px);
          margin-right: 24px;
          margin-bottom: 43px;
          position: relative;

          &:nth-child(4n) {
            margin-right: 0;
          }

          .bottom-li-cover {
            width: 280px;

          }

          .bottom-li-name-big {
            position: absolute;
            top: 40px;
            left: 0;
            padding: 0 22px;
            font-size: 20px;
            letter-spacing: 2px;
            color: #fff;
            line-height: 30px;

            &::before {
              content: '';
              position: absolute;
              top: -5px;
              left: 22px;
              height: 2px;
              width: 25%;
              background-color: #fff;
            }
          }

          .bottom-li-name {
            margin-top: 25px;
            font-size: 16px;
            color: #383838;
            text-align: center;
          }
        }
      }
    }

    @media screen and (max-width:1250px) {
      .container-wrapper {
        width: 990px;
        margin: 36px auto 83px;
      }

      .top-title,
      .bottom-title {
        margin-bottom: 30px;
        font-size: 26px;
        padding: 41px 0 53px;

        &>p {
          font-size: 16px;
          margin-top: 14px;
        }
      }

      .bottom-title {
        padding: 65px 0 58px;
      }

      .top-container {
        margin-bottom: 49px;


        .top-describe {
          line-height: 31px;
          font-size: 13px;
          margin-bottom: 41px;
        }

        .top-li {
          margin-right: 20px;
          border-radius: 8px;
          padding: 38px 17px 24px 19px;
        }

        // .top-li > img {
        //   width: 50px;
        // }

        .top-li-title {
          margin: 30px 0 24px;
          font-size: 17px;
        }

        .top-li-discribe {
          line-height: 20x;
          font-size: 13px;
        }
      }

      .bottom-container {
        .sort-ul {
          padding: 0 240px;
          margin-bottom: 19px;
        }

        .sort-li {
          margin-right: 8px;
          line-height: 34px;
          font-size: 13px;
        }

        .bottom-ul {
          margin-top: 18px;

          .bottom-li {
            display: inline-block;
            width: calc((100% / 4) - 17px);
            margin-right: 22px;
            margin-bottom: 36px;

            .bottom-li-cover {
              width: 231px;
            }

            .bottom-li-name-big {
              position: absolute;
              top: 35px;
              left: 0;
              font-size: 16px;
              letter-spacing: 2px;
              color: #fff;
              line-height: 25px;

              &::before {
                top: -5px;
              }
            }

            .bottom-li-name {
              margin-top: 21px;
              font-size: 13px;
            }
          }
        }
      }
    }
  }
</style>